import { cx } from '../../cx'

const getDotSize = (dotIndex: number, sliderIndex: number, length: number): DotProps['size'] => {
  if (length >= 5) {
    if (dotIndex === 0 && sliderIndex > 2) return 's'
    if (dotIndex === 1 && sliderIndex > 2) return 'md'
    if (dotIndex === 3 && length - sliderIndex > 3) return 'md'
    if (dotIndex === 4 && length - sliderIndex > 3) return 's'
  }
  return 'l'
}

const isDotHighlighted = (dotIndex: number, sliderIndex: number, length: number) => {
  if (length >= 5) {
    if (dotIndex === 2) return sliderIndex >= 2 && length - sliderIndex >= 3
    if (dotIndex === 3) return length - sliderIndex === 2
    if (dotIndex === 4) return length - sliderIndex === 1
  }
  return dotIndex === sliderIndex
}

interface ImageSliderSwipeDotsProps {
  currentIndex: number
  length: number
}

export const ImageSliderSwipeDots = ({ currentIndex, length }: ImageSliderSwipeDotsProps) => {
  return (
    <div className="flex h-5 items-center space-x-2">
      {Array.from({ length: Math.min(5, length) }).map((_, dotIndex) => (
        <Dot
          key={dotIndex}
          size={getDotSize(dotIndex, currentIndex, length)}
          isHighlighted={isDotHighlighted(dotIndex, currentIndex, length)}
        />
      ))}
    </div>
  )
}

interface DotProps {
  size: '0' | 's' | 'md' | 'l'
  isHighlighted: boolean
}

const Dot = ({ size, isHighlighted }: DotProps) => {
  const sizes = {
    '0': 'size-0',
    's': 'size-2',
    'md': 'size-2.5',
    'l': 'size-3',
  }

  return (
    <div className={cx('flex items-center justify-center', sizes[size])}>
      <div
        className={cx(
          sizes[size],
          'rounded-full bg-white transition-opacity duration-150',
          isHighlighted ? 'opacity-full' : 'opacity-50'
        )}
      ></div>
    </div>
  )
}
